import angular from 'angular';
import eventBus from '../../services/eventBus';

class Toast {
  constructor({message, stays = false, styleClass = ''}) {
    this.message = message;
    this.stays = stays;
    this.styleClass = styleClass;
  }
}

angular.module('folkeuni').component('fuToasts', {
  controller: function($scope, $timeout) {
    var $ctrl = this;
    $ctrl.toasts = [];
    
    $ctrl.$onInit = function() {
      // creates a global accessible function to create toasts
      window.addEventListener(eventBus.toast, function(e) {
        $ctrl.addToast(e.detail);
        try {
          $scope.$digest();
        } catch(err){};
      });
    }

    $ctrl.addToast = function(toast) {
      // creates a new instance of toast and apply it to collection
      const newToast = new Toast(toast);
      $ctrl.toasts =  $ctrl.toasts.concat([newToast]);
      
      if (!newToast.stays) {
        // sentence toast to an automatic deletion
        $ctrl.autoCleaner(newToast);
      }
    }

    $ctrl.autoCleaner = function(toast) {
      // removes given toast after some time
      $timeout(function() {
        $ctrl.removeToast(toast);
      }, 10000)
    }

    $ctrl.removeToast = function(toast) {
      // apply closing animation
      toast.styleClass = 'vanish';

      // clean up dom after animation finishes
      $timeout(function() {
        $ctrl.toasts = $ctrl.toasts.filter((toastItem) => {
          return toastItem != toast;
        })
      }, 400)
    }
  },
  templateUrl: '/shop-dist/templates/toasts.html?c=' + window.cacheBurst,
});
